const getElementPath = (element) => {
    if(!element) {
        return;
    }

    if(Array.isArray(element)) {
        return element.map((item) => getElementPath(item));
    }

    if (element?.id !== "") {
        return "//" + element.tagName.toLowerCase() + "[@id=\""+element.id+"\"]";
    }

    if (element===document.body) {
        return element.tagName.toLowerCase();
    }

    let ix= 0;

    if (element.parentNode) {
        let siblings = element.parentNode.childNodes;

        for (let i = 0; i < siblings.length; i++) {
            let sibling = siblings[i];

            if (sibling === element) {
                return getElementPath(element.parentNode) + "/" + element.tagName.toLowerCase() + "[" + (ix + 1) + "]";
            }

            if (sibling.nodeType === 1 && sibling.tagName === element.tagName) {
                ix++;
            }
        }
    }
};

export default getElementPath;
